export const LC_ENGLISH = {
  "datox.lc.title": "LC Document Examination",
  "datox.lc.description": "Examine trade documents, investigate discrepancies and record an evidence-backed officer review.",
  "datox.lc.eyebrow": "Trade finance · Agentic examination",
  "datox.lc.outputs": "Document Examination Report · Source evidence · Agent execution history",
  "datox.lc.use": "Start examination case",
  "datox.lc.demo": "Use demo documents",
  "datox.lc.browse": "View examination cases",
  "datox.lc.workflowResults": "View workflow results",
  "datox.lc.openExamination": "Open LC examination",
  "datox.listing.workflowType.lc": "LC examination",
  "datox.lc.new": "New examination",
  "datox.lc.recent": "Examination cases",
  "datox.lc.empty": "Your LC examination cases will appear here.",
  "datox.lc.name": "Case name",
  "datox.lc.sampleName": "ABC Trading · Export pump assemblies",
  "datox.lc.presentationDate": "Presentation date",
  "datox.lc.sampleHint": "Creates synthetic trade documents with seeded discrepancies. Examination uses live agents; results are not simulated.",
  "datox.lc.sampleBadge": "Synthetic documents · Live agents",
  "datox.lc.scope": "Selected documentary checks against supplied LC terms, with UCP 600 / ISBP 821 examination context. Amendments, originals, signatures, endorsements and authenticity require separate examination.",
  "datox.lc.section.overview": "Overview",
  "datox.lc.section.documents": "Documents & LC terms",
  "datox.lc.section.examination": "Examination matrix",
  "datox.lc.section.discrepancies": "Discrepancy review",
  "datox.lc.section.review": "Review & report",
  "datox.lc.section.governance": "Governance",
  "datox.lc.run": "Run examination",
  "datox.lc.rerun": "New examination revision",
  "datox.lc.running": "Examining this presentation…",
  "datox.lc.runHint": "Upload documents to begin. The agent identifies document types automatically and checks for missing evidence.",
  "datox.lc.noRun": "Run an examination to see source-linked checks and agent findings.",
  "datox.lc.history": "Examination version",
  "datox.lc.current": "Current presentation",
  "datox.lc.historical": "Historical examination · Read only. Changes to the presentation require a new examination.",
  "datox.lc.version": "Input revision {{revision}}",
  "datox.lc.stage.extraction": "Document extraction",
  "datox.lc.stage.validation": "Documentary validation",
  "datox.lc.stage.reporting": "Exception reporting",
  "datox.lc.stage.completed": "Ready for officer review",
  "datox.lc.status.draft": "Draft presentation",
  "datox.lc.status.processing": "Processing",
  "datox.lc.status.ready_for_review": "Ready for review",
  "datox.lc.status.signed_off": "Examination signed off",
  "datox.lc.status.changes_requested": "Changes requested",
  "datox.lc.status.failed": "Execution failed",
  "datox.lc.status.queued": "Queued",
  "datox.lc.status.running": "Running",
  "datox.lc.status.completed": "Completed",
  "datox.lc.completedNeedsReview": "Completed · needs review",
  "datox.lc.governance.recoveredResult": "Available results saved; flagged items require review.",
  "datox.lc.status.superseded": "Superseded",
  "datox.lc.status.interrupted": "Interrupted",
  "datox.lc.outcome.pass": "Passed",
  "datox.lc.outcome.potential_discrepancy": "Potential discrepancy",
  "datox.lc.outcome.conditional_discrepancy": "Conditional discrepancy",
  "datox.lc.outcome.not_assessable": "Needs manual examination",
  "datox.lc.outcome.not_applicable": "Not applicable",
  "datox.lc.outcome.pending_review": "Officer review pending",
  "datox.lc.outcome.limited_examination": "Examination with limitations",
  "datox.lc.outcome.discrepancies_confirmed": "Discrepancies confirmed",
  "datox.lc.outcome.no_discrepancies_identified": "No discrepancies identified in reviewed checks",
  "datox.lc.total": "Checks performed",
  "datox.lc.passed": "Passed checks",
  "datox.lc.discrepancies": "Potential discrepancies",
  "datox.lc.conditional": "Conditional exceptions",
  "datox.lc.countsHint": "Document-presence checks and source qualifications are included in the total. A presence match does not establish documentary compliance.",
  "datox.lc.limitations": "Examination limitations",
  "datox.lc.pending": "Awaiting disposition",
  "datox.lc.requirement": "Requirement / check",
  "datox.lc.result": "Agent / rule result",
  "datox.lc.evidence": "Source evidence",
  "datox.lc.reviewStatus": "Officer disposition",
  "datox.lc.inspect": "Inspect evidence",
  "datox.lc.allChecks": "All checks",
  "datox.lc.noFindings": "No findings match this filter.",
  "datox.lc.lcEvidence": "LC requirement",
  "datox.lc.documentEvidence": "Submitted document evidence",
  "datox.lc.noEvidence": "No supported quotation is available. Review the missing evidence described in this check.",
  "datox.lc.basis": "Examination basis",
  "datox.lc.sourcePage": "Page / section {{page}}",
  "datox.lc.section.extracted": "Extracted data",
  "datox.lc.confidenceCoverage": "{{scored}} of {{total}} extracted fields have confidence scores.",
  "datox.lc.viewExtracted": "View extracted data and confidence",
  "datox.lc.searchExtracted": "Search fields, values, categories or documents",
  "datox.lc.extractedField": "Field",
  "datox.lc.extractedValue": "Extracted value",
  "datox.lc.extractedConfidence": "Confidence (agent estimate)",
  "datox.lc.extractedSource": "Source document",
  "datox.lc.confidenceRerun": "Some saved fields have no confidence score. Run a new examination to request estimates; earlier results will remain unchanged.",
  "datox.lc.confidenceScore": "Extraction confidence (agent estimate): {{score}}%",
  "datox.lc.confidenceUnavailable": "Extraction confidence: not available",
  "datox.lc.confidenceHint": "An uncalibrated agent estimate of how clearly the source supports this field and value. This is not a compliance or approval score.",
  "datox.lc.sourceText": "Frozen source page",
  "datox.lc.viewPage": "View source page",
  "datox.lc.downloadSource": "Download original document",
  "datox.lc.closeSource": "Close source page",
  "datox.lc.field": "Extracted field",
  "datox.lc.value": "Normalized value",
  "datox.lc.field.lc_number": "LC reference",
  "datox.lc.field.beneficiary": "Beneficiary",
  "datox.lc.field.applicant": "Applicant",
  "datox.lc.field.currency": "Currency",
  "datox.lc.field.amount": "Document amount",
  "datox.lc.field.drawing_amount": "Amount presented for drawing",
  "datox.lc.field.quantity": "Quantity",
  "datox.lc.field.unit": "Unit",
  "datox.lc.field.goods_description": "Goods description",
  "datox.lc.field.latest_shipment_date": "Latest shipment date",
  "datox.lc.field.shipment_date": "On-board shipment date",
  "datox.lc.field.expiry_date": "LC expiry date",
  "datox.lc.field.presentation_days": "Express presentation period (days)",
  "datox.lc.field.amount_tolerance_percent": "Express amount tolerance (%)",
  "datox.lc.field.quantity_tolerance_percent": "Express quantity tolerance (%)",
  "datox.lc.field.required_document": "Required document",
  "datox.lc.field.port_loading": "Port of loading",
  "datox.lc.field.port_discharge": "Port of discharge",
  "datox.lc.field.insurance_amount": "Sum insured",
  "datox.lc.field.insurance_percent": "Required insurance (%)",
  "datox.lc.field.insurance_basis": "Insurance calculation basis",
  "datox.lc.field.insurance_date": "Insurance issue date",
  "datox.lc.field.incoterm": "Trade term",
  "datox.lc.field.amendment_status": "Amendment acceptance / applicability",
  "datox.lc.field.amendment_unchanged_terms": "Unchanged amendment terms",
  "datox.lc.field.requirement": "LC requirement",
  "datox.lc.field.document_identity": "Document identity",
  "datox.lc.field.document_reference": "Document reference",
  "datox.lc.field.source_disclaimer": "Source qualification",
  "datox.lc.field.seller": "Seller",
  "datox.lc.field.exporter": "Exporter",
  "datox.lc.field.invoice_issuer": "Invoice issuer",
  "datox.lc.field.shipper": "Shipper",
  "datox.lc.field.insured": "Insured party",
  "datox.lc.field.consignee": "Consignee",
  "datox.lc.field.notify_party": "Notify party",
  "datox.lc.field.issuing_bank": "Issuing bank",
  "datox.lc.field.country_of_origin": "Country of origin",
  "datox.lc.field.freight_terms": "Freight terms",
  "datox.lc.field.insurance_clauses": "Insurance clauses",
  "datox.lc.field.net_weight": "Net weight",
  "datox.lc.field.gross_weight": "Gross weight",
  "datox.lc.field.weight_unit": "Weight unit",
  "datox.lc.field.package_count": "Number of packages",
  "datox.lc.field.units_per_package": "Units per package",
  "datox.lc.field.originals_count": "Stated originals count",
  "datox.lc.field.document_originality": "Original / copy marking",
  "datox.lc.terms": "Evidence-backed LC terms",
  "datox.lc.termsHint": "Terms are extracted from the LC. Correct the source or classification and re-examine if a value is ambiguous or unsupported.",
  "datox.lc.files": "Presentation documents",
  "datox.lc.uploadedDocument": "Uploaded document",
  "datox.lc.fileType": "Document type",
  "datox.lc.upload": "Upload documents",
  "datox.lc.uploadHint": "Upload documents in any file format. Available text and structured data are extracted; unreadable content is flagged for review.",
  "datox.lc.remove": "Remove from presentation",
  "datox.lc.attach": "Attach to presentation",
  "datox.lc.available": "Other files uploaded to this case",
  "datox.lc.document.letter_of_credit": "Letter of Credit",
  "datox.lc.document.invoice": "Commercial invoice",
  "datox.lc.document.bill_of_lading": "Bill of lading",
  "datox.lc.document.packing_list": "Packing list",
  "datox.lc.document.certificate_of_origin": "Certificate of origin",
  "datox.lc.document.insurance": "Insurance document",
  "datox.lc.document.amendment": "LC amendment",
  "datox.lc.document.other": "Other document",
  "datox.lc.findingComments": "Officer rationale",
  "datox.lc.confirm": "Confirm finding / acknowledge limitation",
  "datox.lc.dismiss": "Dismiss with rationale",
  "datox.lc.confirmed": "Confirmed / acknowledged",
  "datox.lc.dismissed": "Dismissed by officer",
  "datox.lc.unreviewed": "Not reviewed",
  "datox.lc.reviewHistory": "Review history",
  "datox.lc.reviewers": "Assigned examination officers",
  "datox.lc.reviewHint": "Record a disposition for every potential discrepancy and limitation. Signing off confirms the examination record, not document acceptance, waiver or payment.",
  "datox.lc.signoff": "Sign off examination",
  "datox.lc.requestChanges": "Request corrected presentation",
  "datox.lc.decisionComments": "Examination conclusion",
  "datox.lc.viewReport": "View examination report",
  "datox.lc.downloadAudit": "Export audit evidence",
  "datox.lc.agentDraft": "Agent draft summary",
  "datox.lc.invocations": "Agent execution history",
  "datox.lc.events": "Workflow audit trail",
  "datox.lc.receipt": "Execution receipt",
  "datox.lc.input": "Supplied agent context",
  "datox.lc.output": "Structured agent response",
  "datox.lc.skills": "Workflow skills",
  "datox.lc.session": "Runtime session",
  "datox.lc.hash": "Input SHA-256",
  "datox.lc.manifest": "Frozen presentation manifest",
  "datox.lc.event.lc.case.created": "Examination case created",
  "datox.lc.event.lc.presentation.changed": "Presentation changed",
  "datox.lc.event.lc.examination.queued": "Examination queued",
  "datox.lc.event.lc.examination.checkpoint": "Examination checkpoint saved",
  "datox.lc.event.lc.examination.completed": "Examination completed",
  "datox.lc.event.lc.examination.failed": "Examination failed",
  "datox.lc.event.lc.agent.started": "Agent execution started",
  "datox.lc.event.lc.agent.completed": "Agent execution completed",
  "datox.lc.event.lc.agent.failed": "Agent execution failed",
  "datox.lc.event.lc.finding.reviewed": "Officer reviewed a finding",
  "datox.lc.event.lc.examination.decided": "Officer recorded examination conclusion",
  "datox.lc.event.lc.chat.opened": "Execution chat opened",
  "datox.lc.governance.description": "Follow each examination stage, inspect its evidence and open the agent conversation.",
  "datox.lc.governance.executions": "Executions",
  "datox.lc.governance.attention": "Need attention",
  "datox.lc.governance.officerActions": "Officer actions",
  "datox.lc.governance.chatHint": "Each chat contains a snapshot of the selected execution for follow-up questions.",
  "datox.lc.governance.openChat": "Open agent chat",
  "datox.lc.governance.conversation": "Agent conversation",
  "datox.lc.governance.continueChat": "Continue in chat",
  "datox.lc.governance.conversationHint": "Recorded request and response for this execution. Continue in chat to ask follow-up questions; examination decisions remain in the LC workspace.",
  "datox.lc.governance.request": "Workflow request",
  "datox.lc.governance.response": "Agent response",
  "datox.lc.governance.openingChat": "Opening chat…",
  "datox.lc.governance.chatError": "Could not open this execution’s chat. Please try again.",
  "datox.lc.governance.details": "Execution details",
  "datox.lc.governance.timestamp": "{{value}} UTC",
  "datox.lc.governance.duration": "{{seconds}}s",
  "datox.lc.governance.filterStage": "Filter execution stage",
  "datox.lc.governance.allStages": "All stages",
  "datox.lc.governance.documentComparison": "Cross-document examination",
  "datox.lc.governance.reportDesign": "Examination report design",
  "datox.lc.governance.inProgress": "This stage is processing the supplied evidence.",
  "datox.lc.governance.noResponse": "No completed response was recorded for this execution.",
  "datox.lc.governance.extractedFields": "Returned {{count}} fields for evidence validation.",
  "datox.lc.governance.assessedChecks": "Returned {{count}} documentary comparisons.",
  "datox.lc.governance.reportPrepared": "Prepared the examination summary and report layout from saved outputs.",
  "datox.lc.governance.presentation": "Evidence snapshot",
  "datox.lc.governance.presentationHint": "These source versions were used for the selected examination.",
  "datox.lc.governance.fingerprint": "Document fingerprint",
  "datox.lc.governance.filterActivity": "Filter audit activity",
  "datox.lc.governance.activity.all": "All activity",
  "datox.lc.governance.activity.officer": "Officer decisions",
  "datox.lc.governance.activity.agent": "Agent executions",
  "datox.lc.governance.noActivity": "No activity matches this filter.",
  "datox.lc.governance.officer": "Bank officer",
  "datox.lc.governance.system": "Automated workflow",
  "datox.lc.skill.custom-report-workflow": "Custom report workflow",
  "datox.lc.skill.export-lc-examination": "LC documentary examination",
  "datox.lc.skill.export-lc-reporting": "LC report design",
  "datox.lc.error": "Could not complete this request. Check the current examination and try again.",
  "datox.lc.error.conflict": "This case changed or the examination is closed. Reload the current state before continuing.",
  "datox.lc.error.forbidden": "Your account does not have permission for this action.",
  "datox.lc.error.input": "Check the presentation, officer comments and outstanding finding dispositions before continuing.",
  "datox.lc.reload": "Reload",
} as const
